import { RouteType } from "types/RouteType";
import ProjectBillingWorkflowStore from "./ProjectBillingWorkflowStore";

const ProjectBillingWorkflowRoute: RouteType = {
  name: "Project Billing Workflow",
  path: "/workflows/project-billing",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Project Billing & Invoicing",
      component: () => import("./ProjectBillingWorkflowHeader"),
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./ProjectBillingWorkflow"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    if (!rootStore.projectBillingWorkflowStore) {
      rootStore.projectBillingWorkflowStore = new ProjectBillingWorkflowStore(
        rootStore
      );
    }
    const store = rootStore.projectBillingWorkflowStore as ProjectBillingWorkflowStore;
    await store.loadInitialData();
    return true;
  },
};

export default ProjectBillingWorkflowRoute;